import i18n from '@/shared/i18n';
import BaseModel, {defineTranslatableProperties} from '@/core/components/input-widget/BaseModel';
import moment from 'moment';
import {SYSTEM_DATE_FORMAT} from '@/core/services/formatter.service';

export default class CustomerSearch extends BaseModel {
  saleDateRange = {startDate: null, endDate: null};
  sale_no = [];
  department_uuids = [];
  billing_country_codes = [];
  shipping_country_codes = [];
  tags = [];
  acquisition_sources = [];
  account_managers_uuids = [];
  statuses = [];
  trust_levels_uuids = [];
  sale_sources = [];
  audience_uuids = [];
  audiences = [];

  rules = {};

  attributeLabels = {
    is_registered_on_sale: i18n.t('Is Registered on Sale'),
    is_not_registered_on_sale: i18n.t('Is Not Registered on Sale'),
    is_bidder: i18n.t('Is Bidder'),
    is_not_bidder: i18n.t('Is Not Bidder'),
    is_underbidder: i18n.t('Is Underbidder'),
    is_not_underbidder: i18n.t('Is Not Underbidder'),
    is_winning_bidder: i18n.t('Is Winning Bidder'),
    is_not_winning_bidder: i18n.t('Is Not Winning Bidder'),
    is_buyer: i18n.t('Is Buyer'),
    is_not_buyer: i18n.t('Is Not Buyer'),
    is_vendor: i18n.t('Is Vendor'),
    is_not_vendor: i18n.t('Is Not Vendor'),
    is_seller: i18n.t('Is Seller'),
    is_not_seller: i18n.t('Is Not Seller'),
    is_company: i18n.t('Is Company'),
    is_not_company: i18n.t('Is Not Company')
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    if (this.saleDateRange.startDate) {
      data.sale_date_after = moment(this.saleDateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.sale_date_before = moment(this.saleDateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    delete data.saleDateRange;
    delete data.audiences;

    return data;
  }
}

defineTranslatableProperties(CustomerSearch);
